import Cookies from 'js-cookie';

export function getToken(TokenKey = 'G_Life_Token') {
  return Cookies.get(TokenKey);
}

export function setToken(TokenKey = 'G_Life_Token', token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken(TokenKey = 'G_Life_Token') {
  return Cookies.remove(TokenKey);
}

export function getSessionToken(TokenKey) {
  let info = sessionStorage.getItem(TokenKey);
  if (info) {
    return JSON.parse(info);
  } else {
    return null;
  }
}

export function setSessionToken(TokenKey, token) {
  return sessionStorage.setItem(TokenKey, JSON.stringify(token));
}

export function removeSessionToken(TokenKey) {
  return sessionStorage.removeItem(TokenKey);
}
